import SessionRepository from './SessionRepository';

export default SessionRepository;
